import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-39f898e8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "page-aftersale",
  class: "page-aftersale"
};
const _hoisted_2 = {
  ref: "header",
  class: "sticky-header"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  id: "moblie-ticket"
}, null, -1));

const _hoisted_4 = {
  id: "main-content",
  class: "main-content"
};
const _hoisted_5 = {
  ref: "banner",
  class: "sticky-banner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoblieHeader = _resolveComponent("MoblieHeader");

  const _component_MoblieBanner = _resolveComponent("MoblieBanner");

  const _component_MoblieCatalog = _resolveComponent("MoblieCatalog");

  const _component_MoblieFooter = _resolveComponent("MoblieFooter");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MoblieHeader)], 512), _hoisted_3, _createElementVNode("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_MoblieBanner)], 512), _createVNode(_component_MoblieCatalog), (_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.activeComponent)))], 1024))]), _createVNode(_component_MoblieFooter)]);
}